$(() => {
  const mapWrapper = $('#map-wrapper');
  const toggleButton = $('#map-toggle-button');
  const photoCarousel = $('.property-header__container');
  const slickElement = $('#property-photos-carousel');

  toggleButton.on('click', () => {
    mapWrapper.toggleClass('active');
    toggleButton.toggleClass('reverse');
    photoCarousel.toggleClass('hide-controls');
    //resize photos carousel after animation
    setTimeout(() => {
      const event = new CustomEvent('mapResized');
      slickElement.get(0).dispatchEvent(event);
    }, 500);
  });
});
